import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * 🚀 Servicio de inicialización de la aplicación
 * Controla el estado de carga inicial
 */
@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  // Subject para rastrear el estado de inicialización
  private initializedSubject = new BehaviorSubject<boolean>(false);
  public initialized$ = this.initializedSubject.asObservable();

  // Signal para componentes
  public isInitialized = signal<boolean>(false);

  // Estado de error (si la inicialización falla)
  private errorSubject = new BehaviorSubject<Error | null>(null);
  public error$ = this.errorSubject.asObservable();

  constructor() {}

  /**
   * Marca la app como inicializada
   */
  markAsInitialized(): void {
    this.initializedSubject.next(true);
    this.isInitialized.set(true);
  }

  /**
   * Marca la app con error
   */
  markAsError(error: Error): void {
    this.errorSubject.next(error);
    this.initializedSubject.next(true); // Permitir que la app continúe
    this.isInitialized.set(true);
  }

  /**
   * Verifica si la app está inicializada
   */
  checkInitialized(): boolean {
    return this.isInitialized();
  }
}
